import React, { useRef } from 'react'
import './add-staff.scss'
import QrCode from 'qrcode'
import { BaseDialog } from '@/components/dialog/base-dialog'
import { layerManage } from '@/utils/layer'
import { useMount } from 'ahooks'
import { Column } from '@/components/layout/layout'
import { getBEMCls } from '@/utils/classname'

const AddStaff = () => {
    const codeRef = useRef<HTMLCanvasElement>(null)

    const cls = (...arg: string[]) => getBEMCls('add-staff', ...arg)

    useMount(() => {
        QrCode.toCanvas(
            codeRef.current,
            `https://${
                process.env.NODE_ENV === 'production' ? 'ls.senguo.cc' : 'cashiertest.senguo.me'
            }/m/#/employess/registe?shopId=${localStorage.getItem('shopId')}`,
            {
                width: 160,
            },
        )
    })

    return (
        <BaseDialog
            isShow
            title=" "
            onClose={() => {
                layerManage.pop()
            }}
        >
            <Column data-align-items-center>
                <div className={cls('title')}>微信扫一扫，成为员工</div>
                <div className={cls('des')}>邀请员工微信扫码提交申请，管理员在后台通过申请即可添加员工</div>
                <div className={cls('container')}>
                    <canvas className={cls('code')} ref={codeRef}></canvas>
                </div>
            </Column>
        </BaseDialog>
    )
}

export default AddStaff
